import type { ReactNode } from "react";
import { cx } from "./cx";

export interface SegmentedOption<T extends string = string> {
  value: T;
  label: ReactNode;
  disabled?: boolean;
}

export interface SegmentedControlProps<T extends string = string> {
  options: Array<SegmentedOption<T>>;
  value: T;
  onChange?: (value: T) => void;
  /** Accessible name for the group (e.g. "Map style"). */
  label: string;
  className?: string;
}

/** Segmented control — map-style switcher, sharing-tier toggle (M4/M6). */
export function SegmentedControl<T extends string = string>({
  options,
  value,
  onChange,
  label,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div role="group" aria-label={label} className={cx("pz-segmented", className)}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className="pz-segmented__option"
          aria-pressed={o.value === value}
          disabled={o.disabled}
          onClick={() => onChange?.(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
